let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1VXlo")).then(() => parcelRequire('5DEXw'));